import { BASE_URL } from "../constants/constants";
import AuthUtils from "../auth/AuthUtils";
const axios = require("axios");
export class FileManagementService {
  public async downloadFile(fileName: String, companyName: any) {
    try {
      let response = await fetch(`${BASE_URL}/files/download`, {
        method: "GET",
        headers: AuthUtils.getHeaders({
          filename: fileName,
          companyName: companyName,
        }),
        credentials: "include"
      });
      if (response.status === 204) {
        return { error: true, message: "File not found" };
      }
      let ret = await response.blob();
      return ret;
    } catch (e) {
      console.log(e);
    }
  }

  public async downloadAll(companyName: any) {
    try {
      let response = await fetch(`${BASE_URL}/files/downloadAll`, {
        method: "GET",
        headers: AuthUtils.getHeaders({
          companyName: companyName,
        }),
        credentials: "include"
      });
      if (response.status === 204) {
        return { error: true, message: "File not found" };
      }
      let ret = await response.blob();
      return ret;
    } catch (e) {
      console.log(e);
    }
  }

  public async deleteFile(fileName: String, companyName: any) {
    try {
      let response = await fetch(`${BASE_URL}/files/delete`, {
        method: "DELETE",
        headers: AuthUtils.getHeaders({
          filename: fileName,
          companyName: companyName,
          credentials: "include"
        }),
      });
      let ret = await response.json();
      if (!response.ok && ret && !ret.success) {
        return {
          error: ret.message,
          status: response.status,
          ok: response.ok,
        };
      }
      return ret;
    } catch (e) {
      console.log(e);
    }
  }

  public async getFileName(companyName: String) {
    try {
      let response = await fetch(`${BASE_URL}/files/names`, {
        method: "GET",
        headers: AuthUtils.getHeaders({ companyName: companyName }),
        credentials: "include"
      });
      let ret = await response.json();
      if (!response.ok && ret && !ret.success) {
        return {
          error: ret.message,
          status: response.status,
          ok: response.ok,
        };
      }
      return ret;
    } catch (e) {
      console.log(e);
    }
  }
  public async uploadFile(multipleFiles: any, companyName: any) {
    var formData = new FormData();
    // allFiles in this example are an array of files from Dropzone onDrop method.
    multipleFiles.forEach((file: any) => formData.append("file", file));
    const config = {
      headers: {
        "content-type": "multipart/form-data",
        "Access-Control-Allow-Origin": "http://localhost:3000",
        companyName: companyName,
        app: "WEB",
      },
    };
    let response = await axios.post(
      `${BASE_URL}/files/upload`,
      formData,
      config,
      { withCredentials: true }
    );
    let ret = response.data;
    if (!ret.success) {
      return {
        error: ret.message,
        status: response.status,
        ok: response.ok,
      };
    }
    return ret;

  }
}
